import { useMutation } from '@tanstack/react-query';

import { dismissProcrastinationSuggestion } from '../api/procrastinationApi';

export function useDismissSuggestion() {
  return useMutation({
    mutationFn: (sessionId: number) => dismissProcrastinationSuggestion(sessionId),
  });
}
